// export const queryRequisitionString = (
//   requisitionId: number
// ) => `query MyQuery {
//    rsRequisition: recruit_rstb_requisition(where: {id: {_eq: ${requisitionId}}}) {
//       id
//       aggId
//       approvalDate
//       authStatus
//       buCode
//       checkerDate
//       checkerId
//       closedDate
//       createDate
//       criticalFlg
//       departmentCode
//       description
//       empCode
//       ftsString
//       ftsValue
//       gender
//       hiringManagerCode
//       justification
//       makerDate
//       makerId
//       modNo
//       priority
//       recordOrder
//       recordStatus
//       requirement
//       workflowId
//       updateId
//       updateDate
//       tenantCode
//       status
//       specialNote
//       sellingPoint
//      rsJobs: rstb_requisition_jobs {
//         id
//         requisitionId
//         jobQuantity
//         jobInfo
//         jobTitle
//         jobTrack
//         jobFamily
//         jobGroup
//         jobSubgroup
//         jobBenefit
//         jobCompetency
//         jobCompliance
//         jobDuty
//         jobEnvironment
//         jobLevel
//         jobLocation
//         jobOppotunity
//         jobPath
//         jobEducation
//         jobSalaryrange
//         jobType
//         jobWorkinghour
//         description
//         recordOrder
//         recordStatus
//         authStatus
//         makerId
//         makerDate
//         checkerId
//         checkerDate
//         modNo
//         createDate
//         ftsValue
//         ftsString
//         tenantCode
//         buCode
//         empCode
//         updateId
//         updateDate
//         aggId
//     }
//     }
//   }
//   `;

// export const queryInsertPostRequisition = `mutation XHuntMutationInsertConnectRequisition($objects: [connect_cstb_requisition_insert_input!] = {}) {
//     insert_connect_cstb_requisition(objects: $objects) {
//       returning {
//         aggId
//       }
//     }
//   }
//     `;

// export const queryInsertPostRequisitionJob = `mutation XHuntMutationInsertConnectRequisitionJob($objects: [connect_cstb_requisition_job_insert_input!] = {}) {
//     insert_connect_cstb_requisition_job(objects: $objects) {
//       returning {
//         aggId
//       }
//     }
//     }
// `;

// export const queryInsertPostingChannel = `mutation XHuntMutationInsertConnectPostingChannel($objects: [connect_cstb_posting_channel_insert_input!] = {}) {
//   insert_connect_cstb_posting_channel(objects: $objects) {
//     returning {
//       aggId
//     }
//   }
// }
// `;

// export const queryInsertXConnectPosting = `mutation XHuntMutationInsertConnectPosting($objects: [connect_cstb_posting_insert_input!]!) {
//   data: insert_connect_cstb_posting(objects: $objects) {
//     affected_rows
//     returning {
//       aggId
//       id
//     }
//   }
// }
// `;

// export const mutationUpdatePosting = (aggId: string) => `mutation XHuntMutationUpdateConnectPosting($_set: connect_cstb_posting_set_input = {}) {
//       data: update_connect_cstb_posting(where: { aggId: {_eq: "${aggId}"}}, _set: $_set) {
//         affected_rows
//       }
//     }
// `

// export const mutationUpdatePostingChannel = (aggId: string) => `mutation XHuntMutationUpdateConnectPostingChannel($_set: connect_cstb_posting_channel_set_input = {}) {
//     data: update_connect_cstb_posting_channel(where: {aggId: {_eq: "${aggId}"}}, _set: $_set) {
//       affected_rows
//     }
//   }
// `

export function convertToHasuraFormat(data) {
  const convertNested = (item) => {
    const keys = Object.keys(item);
    return keys.reduce((acc, key) => {
      if ((key.startsWith("rstb_") || key.startsWith("hrm_")) && Array.isArray(item[key])) {
        acc[key] = { data: item[key].map(convertNested) };
      } else if (
        typeof item[key] === "object" &&
        item[key] !== null &&
        (key.startsWith("rstb_") || key.startsWith("hrm_"))
      ) {
        acc[key] = convertNested(item[key]);
      } else {
        acc[key] = item[key];
      }
      return acc;
    }, {});
  };

  delete data["__typename"];

  return {
    objects: convertNested(data),
  };
}

export const removeSomeFieldInObject = (object: any, keys: string[]) => {
  keys.forEach((key) => {
    delete object[key];
  });
  return object;
};

export enum PostStatus {
  DRAFT = "DRAFT",
  POSTING = "POSTING",
  PENDING = "PENDING",
  DONE = "DONE",
}

export const ButtonLabelWithStatus = {
  [PostStatus.DRAFT]: {
    label: "COMMON.ACTION.SAVE_DRAFT",
    actions: [
      {
        label: "COMMON.ACTION.SAVE_DRAFT",
        status: PostStatus.DRAFT,
        svgIcon: "heroicons_outline:save"
      },
      {
        label: "PREVIEW_JOB.LABEL.TASK.POST_JOB",
        status: PostStatus.POSTING,
        svgIcon: "heroicons_outline:posting"
      }
    ]
  },
  [PostStatus.POSTING]: {
    label: "PREVIEW_JOB.LABEL.TASK.POSTING",
    actions: [
      {
        label: "PREVIEW_JOB.LABEL.TASK.PENDING",
        status: PostStatus.PENDING,
        svgIcon: "heroicons_outline:pending"
      },
      {
        label: "PREVIEW_JOB.LABEL.TASK.REPOST",
        status: PostStatus.POSTING,
        svgIcon: "heroicons_outline:posting"
      },
    ]
  },
  [PostStatus.PENDING]: {
    label: "PREVIEW_JOB.LABEL.TASK.PENDING",
    actions: [
      {
        label: "PREVIEW_JOB.LABEL.TASK.REPOST",
        status: PostStatus.POSTING,
        svgIcon: "heroicons_outline:posting"
      },
    ],
  },
  [PostStatus.DONE]: {
    label: "PREVIEW_JOB.LABEL.TASK.DONE",
    actions: [],
  },
}


export function deleteTypenameKey(obj: any): any {
  if (Array.isArray(obj)) {
    // If the current object is an array, apply the function to each element
    return obj.map(deleteTypenameKey);
  } else if (typeof obj === 'object' && obj !== null) {
    // If the current object is an object, iterate over its keys
    for (const key of Object.keys(obj)) {
      if (key === '__typename') {
        // Delete the __typename key
        delete obj[key];
      } else if (typeof obj[key] === 'object') {
        // If the value is an object or an array, apply the function recursively
        deleteTypenameKey(obj[key]);
      }
    }
  }
  return obj;
}